module.exports = __webpack_public_path__ + "static/media/Salt.54dd9ed2.jpg";